import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseSavedManualCorrections } from './types'

export const useSavedManualCorrections = create<UseSavedManualCorrections>()(
  devtools(
    (set) => ({
      manualCorrections: {},
      clear: () => set({ manualCorrections: {} }),
    }),
    {
      store: 'savedManualCorrections',
    },
  ),
)
